import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { PureComponent } from 'react';

import styles from './teamChannelIcon.module.scss';

type PropsT = {
  className?: string;
  active: boolean;
  icon: string;
  numberOfConversations?: number;
};

export class TeamChannelIcon extends PureComponent<PropsT> {
  render() {
    const { className, active, icon, numberOfConversations, ...otherProps } =
      this.props;

    const withText = numberOfConversations !== undefined;
    const zeroConversations = withText && numberOfConversations === 0;
    const activeWithZeroConversations = !!active && zeroConversations;
    const notActiveWithZeroConversations = !active && zeroConversations;
    const activeWithConversations = !!active && !zeroConversations;
    const notActiveWithConversations = !active && !zeroConversations;
    const withoutTextActive = !withText && !!active;
    const withoutTextNotActive = !withText && !active;

    const rootClass = classnames(
      {
        [styles.iconBackground]: true,
        [styles.iconBackgroundWithoutText]: !withText,
        [styles.iconBackgroundZeroActive]:
          withText && activeWithZeroConversations,
        [styles.iconBackgroundZeroNotActive]:
          withoutTextNotActive || notActiveWithZeroConversations,
        [styles.iconBackgroundPositiveActive]:
          withoutTextActive || activeWithConversations,
        [styles.iconBackgroundPositiveNotActive]:
          withText && notActiveWithConversations,
      },
      className,
    );

    const iconClass = classnames(styles.icon, 'icon-vertical-fix-block');

    const cappedConversations =
      numberOfConversations && numberOfConversations > 9
        ? '9+'
        : numberOfConversations;

    return (
      <div {...otherProps} className={rootClass}>
        <DixaIcon icon={icon} className={iconClass} />
        {withText && <span className={styles.text}>{cappedConversations}</span>}
      </div>
    );
  }
}
